module.exports = __webpack_public_path__ + "img/panelView_blackBg_2_2.1820ee1a.png";